<template>
  <div class="modal modal__theme_discount">
    <PatternModalWindow
      :titleWindow="'Доступна скидка на предмет'"
      :titleWindowMobile="'Доступна скидка'"
      @closeModal="closeModal()"
    >
      <div class="content content__theme_discount">
        <div class="text text__theme_h5">
          40% учеников годового курса занимаются у нас на двух и более предметах.
          И поскольку сегодня ты стал частью «Репетиторской империи», мы хотим подарить тебе скидку {{ discountString }} ₽ на покупку следующего предмета.
          <br/><br/>
          Предложение будет действовать только 60 минут, затем эта страница будет недоступна. Выбирай предмет!
        </div>

        <div class="courses_list">
          <div class="course"
               v-for="item in listCourses"
               :key="'course_' + item.id"
          >
            <div class="course_image"
                 :style="{backgroundImage: `url('${item.image}')`}"
            >
              <div class="course-additional-info">
                <div class="course-info"
                     v-if="discount"
                >
                  <div class="course-info_text">
                    {{'-' + discountString + ' ₽'}}
                  </div>
                </div>

                <div class="course-info"
                     v-if="item.examsData && item.examsData.isShow"
                >
                  <div class="course-info_text">
                    {{item.examsData.title}}
                  </div>
                </div>
              </div>
            </div>

            <div class="course_main">
              <div class="course_content">
                <div class="text text__theme_h4">{{item.title}}</div>

                <div class="block block__theme_info">
                  <div class="text text__theme_h4">{{'от ' + item.currentCostString + ' ₽'}}</div>
<!--                  <div class="text text__theme_lessons block__theme_default">{{'/ ' + item.countLessons + ' занятий'}}</div>
                  <div class="text text__theme_lessons block__theme_small">{{item.countLessons + ' занятий'}}</div>-->
                </div>
              </div>

              <div class="button button__theme_main"
                   @click="subscribeCourse(item.id)"
              >
                Записаться на курс →
              </div>
            </div>
          </div>
        </div>
      </div>
    </PatternModalWindow>
  </div>
</template>

<script>
import PatternModalWindow from "../../../DefaultComponents/ModalWindows/PatternModalWindow";
import {send} from "../../../fetchData";

export default {
  name: "ModalDiscount",
  props: {

  },

  data() {
    return {
      discount: undefined, // скидка
      discountString: '', // скидка в строковом формате
      listCourses: [ // список курсов доступных для покупки
      /*  {
          id: 0,
          title: '',
          image: '',
          oldCost: 1000, // старая цена
          currentCost: 800, // новая цена (старая - сумма скидки)
          currentCostString: '',
          countLessons: 8, // кол-во занятий
        }*/
      ]
    }
  },

  created() {
    this.getData();
  },

  mounted() {

  },

  methods: {
    // получить данные
    getData() {
      this.discount = undefined;
      this.discountString = '';
      this.listCourses = [];

      let data = {
        module: 'get_courses',
      }

      send
        .post('course.php', data)
        .then((response) => {
          console.log('get_courses', response);
          let discount = 0;

          if (response.bonus_timer.is_active) {
            discount = response.bonus_timer.sum;

            this.discount = discount;
            this.discountString = String(discount);
            if (this.discountString.length > 3) {
              this.discountString = this.discountString.split('');
              this.discountString.splice(-3, 0, ' ');
              this.discountString = this.discountString.join('');
            }
          }

          /** Установить данные для курса
           * @param {Object} item - данные конкретного курса от апи
           * @param {String} typeChecked - тип выбранного экзамена по умолчанию
           * @param {Number} yearChecked - год выбранного экзамена по умолчанию
          * */
          let setCourseData = (item, typeChecked = null, yearChecked = null) => {
            let currentCost = item.price_normal - discount;
            let currentCostString = String(currentCost);
            if (currentCostString.length > 3) {
              currentCostString = currentCostString.split('');
              currentCostString.splice(-3, 0, ' ');
              currentCostString = currentCostString.join('');
            }

            this.listCourses.push({
              id: item.id,
              title: item.name,
              image: item.img.full_link,
              oldCost: item.price_normal, // старая цена
              currentCost: currentCost, // новая цена (старая - сумма скидки)
              currentCostString: currentCostString,
              countLessons: item.lessons_count, // кол-во занятий
              examsData: {
                isShow: (typeChecked !== null) && (yearChecked !== null),
                title: `${typeChecked} / ${yearChecked}`,
              }
            })
          }

          if (response.courses) response.courses.forEach((item) => {
            if (!item.is_buy_course) setCourseData(item);
          });

          if (response.product_list) response.product_list.forEach((item) => {
            item.courses.forEach((course) => {
              if (!course.is_buy_course) setCourseData(course, item.type, item.year);
            });
          });
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
        })
    },

    // закрыть модальное окно
    closeModal() {
      this.$emit('closeModal', {})
    },

    // записаться на курс
    subscribeCourse() {
      this.$router.push({ name: 'LandingBuySubject' });
      this.closeModal();
    },
  },

  components: {
    PatternModalWindow,
  }
}
</script>

<style scoped lang="scss">
@import "../../../../style/styles_fonts";

$font_Geometria: Geometria, 'Geometria';

$color_background: #F6F6FB;
$color_background_2: #E3E8F4;
$color_Gray_1: #C5C5C9;
$color_Gray_2: #ABABB2;
$color_Gray_3: #8D909F;
$color_Gray_4: #EBEBEB;
$color_Gray_5: #F2F2F2;
$color_black: #333333;
$color_purple: #8C71FE;
$color_purple_2: #F2F1FF;
$color_purple_3: #E2E2F6;
$color_purple_4: #7B61EB;
$color_purple_5: #6F57D6;
$color_purple_6: #B1A1F2;
$color_red: #FF6597;
$color_green: #89CE54;
$color_cyan: #C0CADC;
$color_yellow: #FFCC48;
$color_cyan_1: #A0B0CC;

$color_whiteHover: #fafafa;

$transition_medium: 0.5s ease;
$transition_fast: 0.25s ease;

$path_img_checkbox: '/lk/gk/img/check.svg';

.modal__theme_discount {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 20;
  width: 100%;
  height: 100%;
}

.course_content .block__theme_default {
  display: flex;
}

.course_content .block__theme_small {
  display: none;
}

.block__row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.block__column {
  display: flex;
  flex-direction: column;
}

.content__theme_discount {
  width: 100%;
  max-width: 886px;
  height: auto;
}

.content__theme_discount {
  display: flex;
  flex-direction: column;
}

.text__theme_h5 {
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 140%;
}

.courses_list {
  margin-top: 22px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: flex-start;
  grid-gap: 28px;
}

.block__theme_info {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.course {
  display: flex;
  flex-direction: column;
  border: 1px solid $color_background_2;
  border-radius: 8px;
  overflow: hidden;

  .course_image {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-top: 58.14%;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    background-color: $color_background_2;
  }

  .course-additional-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    right: 22px;
    top: 15px;
  }

  .course-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: white;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 19px;
    height: 27px;
    padding: 0 8px;
    border-radius: 4px;
    background-color: $color_purple;

    &:not(:first-child) {
      margin-left: 14px;
    }
  }

  .course-info_text {
    margin-top: 2px;
  }
}

.course_main {
  display: flex;
  flex-direction: column;
  margin: 18px 22px 22px 22px;

  .course_content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .text__theme_h4 {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
  }

  .text__theme_lessons {
    margin-left: 4px;
    color: $color_cyan_1;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
  }

  .button__theme_main {
    margin-top: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background-color: $color_purple;
    color: white;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    height: 48px;
    width: 100%;
    transition: $transition_medium;
    cursor: pointer;

    &:hover {
      background-color: $color_purple_4;
    }
  }
}


@media all and (max-width: 1600px) {
  .content__theme_discount {
    max-width: 820px;
    height: auto;
  }

  .text__theme_h5 {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
  }

  .courses_list {
    margin-top: 20px;
    grid-gap: 24px;
  }

  .course_main .text__theme_h4 {
    font-size: 17px;
    line-height: 21px;
  }

  .course_main .button__theme_main {
    height: 46px;
  }
}

@media all and (max-width: 1440px) {
  .content__theme_discount {
    max-width: 740px;
    height: auto;
  }

  .text__theme_h5 {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 140%;
  }

  .courses_list {
    margin-top: 18px;
    grid-gap: 22px;
  }

  .course_main .text__theme_h4 {
    font-size: 16px;
    line-height: 20px;
  }

  .course_main .button__theme_main {
    height: 42px;
    font-size: 15px;
    line-height: 19px;
    border-radius: 6px;
    margin-top: 12px;
  }

  .course .course-additional-info {
    right: 20px;
    top: 12px;
  }

  .course .course-info {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    height: 26px;
    padding: 0 6px;

    &:not(:first-child) {
      margin-left: 12px;
    }
  }

  .course_main {
    display: flex;
    flex-direction: column;
    margin: 16px 20px 20px 20px;
  }
}

@media all and (max-width: 1280px) {
  .content__theme_discount {
    max-width: 696px;
    height: auto;
  }

  .courses_list {
    margin-top: 14px;
    grid-gap: 20px;
  }

  .course .course-additional-info {
    right: 18px;
    top: 10px;
  }

  .course_main {
    display: flex;
    flex-direction: column;
    margin: 15px 18px 18px 18px;
  }
}

@media all and (max-width: 1160px) {

}

@media all and (max-width: 960px) {
  .content__theme_discount {
    max-width: calc(100vw - 28px - 28px - 66px);
    height: auto;
  }

  .courses_list {
    grid-gap: 16px;
  }

  .course_content .block__theme_default {
    display: none;
  }

  .course_content .block__theme_small {
    display: flex;
  }

  .block__theme_info {
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-end;
  }
}

@media all and (max-width: 680px) {
  .block__theme_info {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 6px;
  }

  .course_main .course_content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .course_content .block__theme_default {
    display: flex;
  }

  .course_content .block__theme_small {
    display: none;
  }
}

@media all and (max-width: 600px) {
  .content__theme_discount {
    max-width: 100%;
    height: auto;
  }

  .courses_list {
    margin-top: 12px;
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }

  .course_main .course_content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .course_main .button__theme_main {
    margin-top: 10px;
  }

  .block__theme_info {
    margin-top: 0;
  }
}

@media all and (max-width: 370px) {
  .block__theme_info {
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-end;
    margin-top: 0;
  }

  .course_content .block__theme_default {
    display: none;
  }

  .course_content .block__theme_small {
    display: flex;
  }
}
</style>